module.exports = __webpack_public_path__ + "media/images/app_m3com-e8ab1a7df9bda84990e823d022d5e834.png";